
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20","data-token-name":"replace-video"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M16.911.304a.625.625 0 01-.214.857l-2.59 1.553 1.554 2.59a.625.625 0 01-1.072.643l-1.875-3.125a.625.625 0 01.214-.858L16.053.09a.625.625 0 01.858.215z","fill":"currentColor"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M13.586 2.52a6.249 6.249 0 016.375 4.09.625.625 0 01-1.175.428 5 5 0 00-5.099-3.272.625.625 0 11-.1-1.246zM4.554 13.84a.625.625 0 01.857.213l1.875 3.125a.625.625 0 01-.214.858l-3.125 1.875a.625.625 0 01-.643-1.072l2.589-1.553-1.554-2.59a.625.625 0 01.215-.857z","fill":"currentColor"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M.411 12.589a.625.625 0 01.801.373 5 5 0 005.1 3.272.625.625 0 01.1 1.246 6.25 6.25 0 01-6.374-4.09.625.625 0 01.373-.801zM12.5 9.375c0-.345.28-.625.625-.625h5A1.875 1.875 0 0120 10.625v7.5A1.875 1.875 0 0118.125 20h-7.5a1.875 1.875 0 01-1.875-1.875v-5a.625.625 0 111.25 0v5a.624.624 0 00.625.625h7.5a.624.624 0 00.625-.625v-7.5a.624.624 0 00-.625-.625h-5a.625.625 0 01-.625-.625z","fill":"currentColor"}}),_c('rect',{attrs:{"x":".625","y":".625","width":"9.75","height":"9.75","rx":"1.375","stroke":"currentColor","stroke-width":"1.25"}}),_c('path',{attrs:{"d":"M4.16 7.453a.456.456 0 01-.66-.409V3.957a.457.457 0 01.66-.409l3.087 1.544a.456.456 0 010 .816L4.16 7.453zm9 8.998a.456.456 0 01-.66-.408v-3.087a.457.457 0 01.66-.409l3.087 1.544a.456.456 0 010 .817L13.16 16.45z","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    